'use client';
// -------------- 组件 -------------------- //
import SafeLink from '@/components/SafeLink';
import JDIPrice from '@/components/price';
// --------------  图标 -------------------- //
import ArrowRight from '@/assets/icons/ArrowRight.svg';
import LowPrice from '@/assets/icons/lowPrice.svg';
// -------------- scss -------------------- //
import CDNImage from '@/components/cdnImage/cdnImage';
import styles from './style.module.scss';
// ---------------引入埋点------------------
import { useTranslation } from '@/i18n/client';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/30451';

export default function Module({
  moduleData,
  index,
  localInfo,
}: {
  moduleData: any;
  index: number;
  localInfo: any;
}) {
  const { externalData } = moduleData;
  const { t } = useTranslation();
  return (
    <div
      className={styles['uk-h5-dutch-auction']}
      exptag={'exp|' + EXPOSURE_RECORD.Home_DutchAuction_Expo}
      data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
      data-exptag-json-param={JSON.stringify({
        index,
      })}
    >
      <div className={styles.header}>
        <span className={styles.headerTitle}>{t('auction.title')}</span>
        <div className={styles.buttonContainer}>
          <SafeLink
            href={
              externalData?.data[0]?.type === 1
                ? '/promo/dutch-auction?tab=0'
                : '/promo/dutch-auction?tab=1'
            }
            onClick={() => {
              sendClickTrack.Home_DutchAuction_More();
            }}
          >
            <div
              className={styles.headerButton}
              exptag={'exp|' + EXPOSURE_RECORD.Home_DutchAuction_More_Expo}
              data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
              data-exptag-json-param={JSON.stringify({})}
            >
              <p>{t('auction.priceDrop')}</p>
              <ArrowRight className={styles.headerIcon} />
            </div>
          </SafeLink>
        </div>
      </div>
      <div className={styles.cardContainer}>
        {externalData &&
          externalData.data.map((item: any, index: any) => {
            return (
              <button
                className={styles.card}
                key={`${item.categoryTabName}-${index}`}
                onClick={() => {
                  sendClickTrack.Home_DutchAuction({
                    index,
                  });
                  item.type === 1
                    ? (location.href = '/promo/dutch-auction?tab=0')
                    : (location.href = '/promo/dutch-auction?tab=1');
                }}
              >
                <CDNImage
                  style={{
                    borderRadius: '4px',
                    opacity: '0.98',
                    // background: "#000",
                  }}
                  src={item.imageUrl}
                  width={80}
                  height={80}
                />

                {item.type === 1 ? (
                  <div className={styles.desContain}>
                    {item.currentPrice && item.startPrice !== item.currentPrice ? (
                      <div className={styles.cardTitle}>
                        <JDIPrice
                          locale={localInfo?.languageCode}
                          currency={localInfo?.currencyCode}
                          price={item.startPrice}
                          uiType={1}
                          containerStyle={{
                            fontSize: '12px',
                            lineHeight: '12px',
                            height: '12px',
                            color: 'var(--sys-Text-Tertiary);',
                          }}
                          integerStyle={{
                            fontSize: '12px',
                            lineHeight: '12px',
                            height: '12px',
                            color: 'var(--sys-Text-Tertiary);',
                          }}
                        />
                        <LowPrice className={styles.priceIcon} />
                      </div>
                    ) : (
                      <div className={styles.cardTitle}>
                        <span className={styles.becomingPrice}>{t('auction.starting')}</span>
                      </div>
                    )}
                    <div className={styles.realPrice}>
                      {Number(item.currentPrice) >= 100000 ? (
                        <JDIPrice
                          locale={localInfo?.languageCode}
                          currency={localInfo?.currencyCode}
                          price={item.currentPrice ? item.currentPrice : item.startPrice}
                          uiType={1}
                          containerStyle={{
                            fontSize: '12px',
                            lineHeight: '18px',
                            height: '18px',
                            color: 'var(--sys-color-Primary700);',
                          }}
                          integerStyle={{
                            fontSize: '16px',
                            lineHeight: '18px',
                            height: '18px',
                            color: 'var(--sys-color-Primary700);',
                          }}
                        />
                      ) : (
                        <JDIPrice
                          locale={localInfo?.languageCode}
                          currency={localInfo?.currencyCode}
                          price={item.currentPrice ? item.currentPrice : item.startPrice}
                          uiType={1}
                          containerStyle={{
                            fontSize: '12px',
                            lineHeight: '18px',
                            height: '18px',
                            color: 'var(--sys-color-Primary700);',
                          }}
                          integerStyle={{
                            fontSize: '18px',
                            lineHeight: '18px',
                            height: '18px',
                            color: 'var(--sys-color-Primary700);',
                          }}
                        />
                      )}
                    </div>
                    <div className={styles.userNum}>{item.viewers}</div>
                  </div>
                ) : (
                  <div className={styles.desContain}>
                    <div className={styles.cardTitle}>
                      <span className={styles.becomingPrice}>{t('auction.starting')}</span>
                    </div>
                    <div className={styles.realPrice}>
                      {Number(item.startPrice) >= 100000 ? (
                        <JDIPrice
                          locale={localInfo?.languageCode}
                          currency={localInfo?.currencyCode}
                          price={item.startPrice}
                          uiType={1}
                          containerStyle={{
                            fontSize: '12px',
                            lineHeight: '18px',
                            height: '18px',
                            color: '#1A1A1A',
                          }}
                          integerStyle={{
                            fontSize: '16px',
                            lineHeight: '18px',
                            height: '18px',
                            color: '#1A1A1A',
                          }}
                        />
                      ) : (
                        <JDIPrice
                          locale={localInfo?.languageCode}
                          currency={localInfo?.currencyCode}
                          price={item.startPrice}
                          uiType={1}
                          containerStyle={{
                            fontSize: '12px',
                            lineHeight: '18px',
                            height: '18px',
                            color: '#1A1A1A',
                          }}
                          integerStyle={{
                            fontSize: '18px',
                            lineHeight: '18px',
                            height: '18px',
                            color: '#1A1A1A',
                          }}
                        />
                      )}
                    </div>
                    <div className={styles.userNum}>{item.viewers}</div>
                  </div>
                )}
              </button>
            );
          })}
      </div>
    </div>
  );
}
